import React, { useState, useEffect } from 'react';
import ItemSelector from "../../../../../components/controls/itemSelector.jsx";


export default function CalculatedUserFields({ dataRule, calculatedUserFieldsList }) {
    const [items, setItems] = useState([]);

    useEffect(() => mountProperties(), [dataRule, calculatedUserFieldsList]);

    return <div className="dm-container dm-no-padding">
        <ItemSelector
            items={items}
            selectedItemsChanged={selectedItemsChanged} />
    </div>;

    function mountProperties() {
        if (!dataRule || !calculatedUserFieldsList) {
            setItems([]);
            return;
        }

        let itemsLocal = Array.isArray(calculatedUserFieldsList) && calculatedUserFieldsList.length ? calculatedUserFieldsList : [];
        itemsLocal.forEach(i => i.isSelected = dataRule.calculatedUserFields.some(id => id == i.id));

        setItems(itemsLocal);
    }

    function selectedItemsChanged(selectedItems) {
        if (ruleChanged)
            ruleChanged({
                ...dataRule,
                calculatedUserFields: selectedItems ? selectedItems.map(i => i.id) : [],
                isUpdated: true
            });
    }
}